import { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
// import contactImg from "../assets/img/contact-img.svg";
import { toast } from 'react-toastify';
import 'animate.css';

export const Contact = ({ homePageData }) => {

  // const url = process.env.REACT_APP_URL
  const mailUrl = process.env.REACT_APP_MAILSERVER
  const appMailUser = process.env.REACT_APP_MAILUSER
  const appMailPass = process.env.REACT_APP_MAILPASS

  // console.log(homePageData?.contact?.to)

  const formInitialDetails = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: '',

  }
  const [formDetails, setFormDetails] = useState(formInitialDetails);

  const onFormUpdate = (category, value) => {
    setFormDetails({
      ...formDetails,
      [category]: value
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('formDetails: ', formDetails);

    const emailToSend = {
      appMailUser,
      appMailPass,
      toList: Array.isArray(homePageData?.contact?.to) ? homePageData.contact.to : [],
      from: formDetails.email,
      replyTo: formDetails.email,
      subject: homePageData?.contact?.subject
        ? homePageData?.contact?.subject
        : 'Contact message from your toastmasters website',
      html: `
        <h3>${homePageData?.contact?.subject || 'Contact message from your toastmasters website'}</h3>
        <p>
          Sender: ${formDetails.firstName} ${formDetails.lastName}<br/>
          Phone number: ${formDetails.phone}<br/>
          Email Address: ${formDetails.email}
        </p>
        <h4>Message:</h4>
        <p>${formDetails.message}</p>
        <p>Signed: ${formDetails.firstName} ${formDetails.lastName}</p>
      `,
    };

    try {
      const response = await fetch(`${mailUrl}/html`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(emailToSend),
      });

      if (response.ok) {
        toast.success(`Email sent successfully`);
        setFormDetails(formInitialDetails); // Reset the form inputs
        document.activeElement.blur(); // Remove focus from the form
      } else {
        const errorResponse = await response.json();
        toast.error(`Failed to send email! ${errorResponse.error || response.statusText}`);
      }
    } catch (error) {
      toast.error(`Error sending the email! ${error.message}`);
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key === 'Enter') {
        e.preventDefault();
        handleSubmit(e); // Trigger handleSubmit when CTRL+Enter is pressed
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
    // eslint-disable-next-line
  }, [formDetails]); // Add formDetails as a dependency to ensure the latest state is used


  return (
    <section className="contact" id="connect">
      <Container>
        <Row className="align-items-center">
          {/* <Col size={12} md={6}>
              <img className={"animate__animated animate__zoomIn" } src={contactImg} alt="Contact Us"/>
          </Col> */}
          <Col xs={12} md={12} xl={12}>

            <div className={"animate__animated animate__fadeIn"}>
              <h2>Get In Touch</h2>
              <form onSubmit={handleSubmit}>
                <Row>
                  <Col size={12} sm={6} className="px-1">
                    <input type="text" value={formDetails.firstName} placeholder="First Name" onChange={(e) => onFormUpdate('firstName', e.target.value)} />
                  </Col>
                  <Col size={12} sm={6} className="px-1">
                    <input type="text" value={formDetails.lastName} placeholder="Last Name" onChange={(e) => onFormUpdate('lastName', e.target.value)} />
                  </Col>
                  <Col size={12} sm={6} className="px-1">
                    <input type="email" value={formDetails.email} placeholder="Email Address" onChange={(e) => onFormUpdate('email', e.target.value)} />
                  </Col>
                  <Col size={12} sm={6} className="px-1">
                    <input type="tel" value={formDetails.phone} placeholder="Phone No." onChange={(e) => onFormUpdate('phone', e.target.value)} />
                  </Col>
                  <Col size={12} className="px-1">
                    <textarea rows="6" value={formDetails.message} placeholder="Message" onChange={(e) => onFormUpdate('message', e.target.value)}></textarea>
                    <button type="submit"><span>Send Email</span></button>
                  </Col>
                </Row>
              </form>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}